import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'
import { ClientRouterMap } from '@/router/clientIndex'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/admin/dashboard/welcome',
    component: Layout,
    name: 'Welcome',
    meta: {
      title: t('router.welcome'),
      icon: 'vi-ant-design:dashboard-filled',
      noCache: true,
      affix: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Admin/Dashboard/Welcome.vue'),
        name: 'WelcomeIndex',
        meta: {
          hidden: true
        }
      }
    ]
  },
  {
    path: '/admin/tenant/tenant-select',
    name: 'TenantSelect',
    component: () => import('@/views/Admin/System/Tenant/TenantSelect.vue'),
    meta: {
      title: t('tenant.select'),
      hidden: true,
      canTo: true,
      requiresAuth: true
    }
  },
  {
    path: '/admin/personal',
    component: Layout,
    redirect: '/Common/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Common/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = []

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: [...ClientRouterMap, ...constantRouterMap] as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
